<template>
  <v-content v-if="loading">
    <transition name="fade">
      <loading v-if="isLoading"></loading>
    </transition>
    <!-- 提示框 -->
    <confirm ref="myAlert"></confirm>

    <v-row class="rows btn-group">

      <!-- 开始时间 -->
      <v-menu ref="menu1"
              class="menu-style"
              v-model="menu1"
              :close-on-content-click="false"
              :return-value.sync="date.startTime"
              transition="scale-transition"
              offset-y
              min-width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="date.startTime"
                        label="开始时间"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"></v-text-field>
        </template>
        <v-date-picker v-model="date.startTime"
                       locale="zh-cn"
                       no-title
                       scrollable>
          <v-spacer></v-spacer>
          <v-btn text
                 color="primary"
                 @click="menu1 = false">
            取消
          </v-btn>
          <v-btn text
                 color="primary"
                 @click="$refs.menu1.save(date.startTime)">
            确定
          </v-btn>
        </v-date-picker>
      </v-menu>

      <!-- 结束时间 -->
      <v-menu ref="menu2"
              class="menu-style"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="date.endTime"
              transition="scale-transition"
              offset-y
              min-width="290px">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field v-model="date.endTime"
                        label="结束时间"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"></v-text-field>
        </template>
        <v-date-picker v-model="date.endTime"
                       locale="zh-cn"
                       no-title
                       scrollable>
          <v-spacer></v-spacer>
          <v-btn text
                 color="primary"
                 @click="menu2 = false">
            取消
          </v-btn>
          <v-btn text
                 color="primary"
                 @click="$refs.menu2.save(date.endTime)">
            确定
          </v-btn>
        </v-date-picker>
      </v-menu>

      <v-btn @click="select">查询</v-btn>
    </v-row>

    <v-flex class="table-style">
      <v-data-table :headers="headers"
                    :items="tableData"
                    item-key="typeId"
                    show-select
                    class="elevation-1">
      </v-data-table>
    </v-flex>

  </v-content>
</template>


<script>
import Loading from '@/components/core/Loading' //引入新闻列表分页 api 接口

export default {
  components: { Loading },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: '顺序号',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        { text: '访问时间', value: 'viewedDate' },
        { text: ' IP地址', value: 'ip' },
      ],
      tableData: [],
      date: {
        startTime: new Date("2020/1/2").toISOString().substr(0, 10),
        endTime: new Date("2021/1/1").toISOString().substr(0, 10),
      },
      menu1: false,
      menu2: false,
    }
  },
  created () {
    this.init();
  },
  mounted () {
    this.$emit("updateNavigationValue", 1)
  },
  methods: {
    init () {
      this.isLoading = true;
      this.$store
        .dispatch("GetViewedList", this.date)
        .then(response => {
          this.tableData = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
      this.loading = true;
    },

    select () {
      this.isLoading = true;
      this.$store
        .dispatch("GetViewedList", this.date)
        .then(response => {
          this.tableData = response.data.data;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }

  }
}
</script>

<style scoped>
.rows {
  margin: 0;
  justify-items: center;
  align-items: center;
  flex-wrap: initial !important;
}
.btn-group {
  flex: none !important;
  width: 300px;
}
.btn-group >>> .v-btn {
  margin: 5px;
  background: cadetblue !important;
}
.table-style {
  width: 98%;
  height: 680px;
  overflow: auto;
}

.add-title {
  width: 100px;
  flex: none;
}
.add-field {
  width: 300px;
  flex: none;
}
.sh-file {
  width: 100px;
  float: left;
  flex: none;
}
.in-file {
  width: 300px;
  flex: none;
}

.type-note {
  max-width: 400px !important;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>